/* eslint-disable @typescript-eslint/no-explicit-any */
import { getIn } from 'final-form';

import { DecisionFormFieldsNamesTemplatesEnum } from '../enums/DecisionFormFieldsNamesTemplatesEnum';
import { decisionFieldsDataByFlatNameMap } from '../constants/decisionFieldsDataByFlatNameMap';
import { IDecisionFormRef } from '../interfaces/IDecisionFormRef';

export const getDecisionErrorFieldDataByFlatName = (flatName: string, formRef: IDecisionFormRef) => {
  const nameTemplate: DecisionFormFieldsNamesTemplatesEnum = flatName.replace(/\[(.+?)\]/g, '[i]') as any;
  const flatNameSplit = flatName.split('.');
  const fieldsDataByFlatNameMap = decisionFieldsDataByFlatNameMap();

  const isArrayInDeepLevel = nameTemplate.split('.').findIndex(name => name.includes('[i]')) > 0;

  // для полей большой вложенности в несколько массивов
  if (nameTemplate.split('[i].').length > 2 || isArrayInDeepLevel) {
    let complexScrollElementId: string = '';
    let previousParentFieldName: string = '';

    flatNameSplit.forEach(name => {
      if (name.includes('[')) {
        const parentFieldName = name;
        const parentFieldArrayIndex = parentFieldName?.substring(
          parentFieldName.lastIndexOf('[') + 1,
          parentFieldName.lastIndexOf(']'),
        );

        if (parentFieldName && parentFieldArrayIndex) {
          const parentFieldArrayName = parentFieldName.replace(/\[(.+?)\]/g, '');

          previousParentFieldName =
            previousParentFieldName?.length > 0
              ? `${previousParentFieldName}.${parentFieldArrayName}`
              : parentFieldArrayName;

          // Значение берём из values, а не из getFieldState: поле внутри свёрнутого
          // аккордеона во final-form не зарегистрировано, и getFieldState вернёт undefined
          const parentFieldValue = getIn(formRef.current.getState().values, previousParentFieldName)?.[
            parentFieldArrayIndex
          ];

          const parentFieldId = parentFieldValue?.listId || parentFieldValue?.guid || parentFieldArrayIndex;

          complexScrollElementId += `${parentFieldName.replace(`[${parentFieldArrayIndex}]`, `[${parentFieldId}]`)}.`;
          previousParentFieldName += `[${parentFieldArrayIndex}]`;
        }
      } else {
        complexScrollElementId += `${name}.`;
        previousParentFieldName += `${previousParentFieldName ? '.' : ''}${name}`;
      }
    });

    const scrollElementId = fieldsDataByFlatNameMap[nameTemplate]
      ?.getScrollElementId(complexScrollElementId.substring(0, complexScrollElementId.length - 1))
      .replace('undefined', '0');

    return {
      nameTemplate,
      title: fieldsDataByFlatNameMap[nameTemplate]?.title,
      scrollElementId,
      parentElementId: undefined,
    };
  }

  const parentFieldName: DecisionFormFieldsNamesTemplatesEnum | undefined =
    flatNameSplit.length > 1 ? (flatNameSplit[0] as any) : undefined;
  const parentFieldArrayIndex = parentFieldName?.substring(
    parentFieldName.lastIndexOf('[') + 1,
    parentFieldName.lastIndexOf(']'),
  );
  let parentFieldId: string | undefined;
  let parentFieldElementId;

  if (parentFieldName && parentFieldArrayIndex) {
    const parentFieldArrayName = parentFieldName.replace(/\[(.+?)\]/g, '');

    // Блоки, у которых в id элемента лежит не listId, а индекс в массиве,
    // иначе ссылка вела бы на первый элемент списка
    parentFieldId =
      getIn(formRef.current.getState().values, parentFieldArrayName)?.[parentFieldArrayIndex]?.listId ||
      parentFieldArrayIndex;
  }

  const field = decisionFieldsDataByFlatNameMap()[nameTemplate];

  const scrollElementId = field?.getScrollElementId(parentFieldId)?.replace('undefined', '0');

  return {
    nameTemplate,
    title: field?.title,
    scrollElementId,
    parentElementId: parentFieldElementId,
  };
};
